import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    selectMe: 'School',
    address: '',
    email: '',
    phone: '',
    fax: '',
    message: ''
  });

  useEffect(() => {
    document.title = 'Contact Us | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.fullName) {
      alert("Please Enter Your FullName");
      return;
    }
    if (!formData.email) {
      alert("Please Enter Your Email Address");
      return;
    }
    if (!formData.phone) {
      alert("Please Enter Your Contact Number");
      return;
    }
    if (!formData.message) {
      alert("Please Enter Your Message");
      return;
    }

    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    alert('Thank you for your message. We will get back to you soon!');
    
    // Reset form
    setFormData({
      fullName: '',
      selectMe: 'School',
      address: '',
      email: '',
      phone: '',
      fax: '',
      message: ''
    });
  };

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <div id="stick_right"></div>
        <div className="container" style={{marginTop: '50px'}}>
      <div className="row">
        <div className="col-lg-4 col-lg-offset-1">
          <h4>Contact Form</h4>
          <div className="panel panel-default" style={{padding: '10px'}}>
            <form onSubmit={handleSubmit}>
              <input 
                className="form-control" 
                placeholder="Name" 
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
              />
              <br/>
              
              <select 
                className="form-control" 
                name="selectMe"
                value={formData.selectMe}
                onChange={handleChange}
              >
                <option value="School">School</option>
                <option value="College">College</option>
                <option value="Club">Club</option>
              </select>
              <br/>
              
              <textarea 
                className="form-control" 
                rows="2" 
                placeholder="Address" 
                name="address"
                value={formData.address}
                onChange={handleChange}
              ></textarea>
              <br/>
              
              <input 
                className="form-control" 
                placeholder="Email" 
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
              <br/>
              
              <input 
                className="form-control" 
                placeholder="Contact Number" 
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
              <br/>
              
              <input 
                className="form-control" 
                placeholder="Fax Number"
                name="fax"
                value={formData.fax}
                onChange={handleChange}
              />
              <br/>
              
              <textarea 
                className="form-control" 
                rows="3" 
                placeholder="Message" 
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              <br/>
              
              <input 
                type="submit" 
                className="btn btn-primary" 
                value="Send"
              />
            </form>
          </div>
        </div>
        
        <div className="col-lg-6">
          <h4>Our Location</h4>
          <iframe
            className="contact1"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3498.4982344566705!2d77.0959874!3d28.7489472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d06e3c1c6b3b9%3A0x7d3e0d8b8e8c8d8e!2sKhera%20Khurd%2C%20Delhi%20110082!5e0!3m2!1sen!2sin!4v1709460000000!5m2!1sen!2sin"
            style={{border: 0, height: '400px', width: '100%'}}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
      
      <div className="row" style={{marginTop: '30px'}}>
        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="heading3">Contact Information</h3>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <h4><i className="fa fa-map-marker"></i> Address</h4>
                  <p>
                    House No. 336, Village - Khera Khurd,<br />
                    Delhi - 110082, India
                  </p>
                </div>
                <div className="col-md-4">
                  <h4><i className="fa fa-phone"></i> Phone</h4>
                  <p>+91 99999 69966</p>
                </div>
                <div className="col-md-4">
                  <h4><i className="fa fa-envelope"></i> Email</h4>
                  <p>nareshmannthrowballindia@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      
      </div>

      <PublicFooter />
    </div>
    
  );
};

export default ContactUsPage;